// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"86d3d463","64":"78d79545","425":"0f9df1fc","545":"f029c36e","969":"2715765d","976":"1bd991d5"}[chunkId] + ".chunk.js";
};